import { render } from "./ReportError.vue?vue&type=template&id=ff7245c8&scoped=true"
import script from "./ReportError.vue?vue&type=script&lang=js"
export * from "./ReportError.vue?vue&type=script&lang=js"

import "./ReportError.vue?vue&type=style&index=0&id=ff7245c8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7245c8"]])

export default __exports__